// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CPsU","option":"styles_option__uapgy","selected":"styles_selected__30MAW"};